var _radialGradient, _radialGradient2, _radialGradient3, _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(14.50001629 -20.99998838 20.99998838 14.50001629 12 23)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#c62f94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a3ac8"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(9.49998144 -20.49995674 20.49995674 9.49998144 11 31)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e8b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#fb8a2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#e2425c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2425c",
    stopOpacity: 0
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(38.50002699 -5.50000224 1.17639341 8.23475632 .500002 3)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406adc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6a45be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6a45be",
    stopOpacity: 0
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#a)",
    height: 28,
    rx: 6,
    width: 28,
    x: 2,
    y: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#b)",
    height: 28,
    rx: 6,
    width: 28,
    x: 2,
    y: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#c)",
    height: 28,
    rx: 6,
    width: 28,
    x: 2,
    y: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23 10.5c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5c0-.82843.6716-1.5 1.5-1.5s1.5.67157 1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m16 21c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5-5 2.2386-5 5 2.2386 5 5 5zm0-2c1.6569 0 3-1.3431 3-3s-1.3431-3-3-3-3 1.3431-3 3 1.3431 3 3 3z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m6 15.6c0-3.3603 0-5.0405.65396-6.32394.57524-1.12898 1.49312-2.04686 2.6221-2.6221 1.28344-.65396 2.96364-.65396 6.32394-.65396h.8c3.3603 0 5.0405 0 6.3239.65396 1.129.57524 2.0469 1.49312 2.6221 2.6221.654 1.28344.654 2.96364.654 6.32394v.8c0 3.3603 0 5.0405-.654 6.3239-.5752 1.129-1.4931 2.0469-2.6221 2.6221-1.2834.654-2.9636.654-6.3239.654h-.8c-3.3603 0-5.0405 0-6.32394-.654-1.12898-.5752-2.04686-1.4931-2.6221-2.6221-.65396-1.2834-.65396-2.9636-.65396-6.3239zm9.6-7.6h.8c1.7132 0 2.8777.00156 3.7779.0751.8769.07164 1.3253.20149 1.6381.36087.7526.3835 1.3645.99542 1.748 1.74803.1594.3128.2893.7612.3609 1.6381.0735.9002.0751 2.0647.0751 3.7779v.8c0 1.7132-.0016 2.8777-.0751 3.7779-.0716.8769-.2015 1.3253-.3609 1.6381-.3835.7526-.9954 1.3645-1.748 1.748-.3128.1594-.7612.2893-1.6381.3609-.9002.0735-2.0647.0751-3.7779.0751h-.8c-1.7132 0-2.8777-.0016-3.7779-.0751-.8769-.0716-1.3253-.2015-1.6381-.3609-.75261-.3835-1.36453-.9954-1.74803-1.748-.15938-.3128-.28923-.7612-.36087-1.6381-.07354-.9002-.0751-2.0647-.0751-3.7779v-.8c0-1.7132.00156-2.8777.0751-3.7779.07164-.8769.20149-1.3253.36087-1.6381.3835-.75261.99542-1.36453 1.74803-1.74803.3128-.15938.7612-.28923 1.6381-.36087.9002-.07354 2.0647-.0751 3.7779-.0751z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ea36c994416d9dd41d8d0e9f5f3af53d.svg";
export { ForwardRef as ReactComponent };